import React from "react";
import ManageGallerySection from "./ManageGallerySection";

export default function ManageGalleryInauguration() {
  return (
    <ManageGallerySection
      sectionKey="inauguration"
      sectionTitle="Inauguration Ceremony"
      sectionDescription="Upload, edit, and remove inauguration ceremony photos and videos."
    />
  );
}
